module.exports = __webpack_public_path__ + "static/media/cross.68f52a7f.svg";